import { getFromLocalStorage } from "./utils.js";

export const heatmapActivityOptions = [
  { value: "openTracking", label: "Opens", default: true },
  { value: "clickTracking", label: "Clicks" },
  { value: "replyTracking", label: "Replies" },
];

export const storedHeatmapUser = getFromLocalStorage("heatmapUser");
